import React, { useState } from 'react';
import TextInputField from '../../../form/components/TextInput';
import styles from './SearchInput.module.scss';
export const SearchInput = ({ searchTerm, handleSearch, placeholder, setSearchTerm, analytics, }) => {
    const [hasTriggeredAnalytics, setHasTriggeredAnalytics] = useState(false);
    const onChange = (value) => {
        setSearchTerm(value);
        handleSearch(value);
    };
    const triggerAnalytics = () => {
        if (!hasTriggeredAnalytics && analytics) {
            setHasTriggeredAnalytics(true);
            analytics({
                event: 'visitor interaction',
                interactionName: 'form field engaged',
                formName: 'search',
                formField: 'park multi select',
            });
        }
    };
    return (<div className={styles.searchInputContainer}>
      <TextInputField id='textSearch' type='search' onChange={(value) => onChange(value)} onFocus={triggerAnalytics} name='Search' label={placeholder || 'Type to search'} value={searchTerm} showTopLabel={false}/>
    </div>);
};
